// extracted by mini-css-extract-plugin
export default {"pipelineBoard":"PipelineBoard_pipelineBoard__-7lXl","stage":"PipelineBoard_stage__JBl6a","actions":"PipelineBoard_actions__hs2X6","addStage":"PipelineBoard_addStage__tJD2C"};